// utils/paymentPopup.js
export const startPayment = async (userCode, navigate, setStateSnackbarContext,isAdmin,stopLoader) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_BASEURL}/payments/create-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        amount:isAdmin?100:99900, // in paise (₹999)
        currency: "INR",
        userCode: userCode,
        source: "dashboard",
      }),
    });

    const data = await res.json();

    if (data.message === "session expired") {
      return navigate("/login");
    }

    // Razorpay options
    const options = {
      key:process.env.REACT_APP_RAZORPAYSECRET,
      currency: data.currency,
      name: "Aamantran Smart Invites",
      description: "Upgrade to Full Invite",
      order_id: data.id,

      handler: function (response) {
        // Send verification to backend
        fetch(`${process.env.REACT_APP_BASEURL}/payments/verify`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
            amount: data.amount,
            currency:data.currency
          }),
        })
          .then((res) => res.json())
          .then((verifyData) => {
            if (verifyData.success) {
              setStateSnackbarContext(
                true,
                "✅ Payment successful & Invite unlocked!",
                "success"
              );
              window.location.reload();
            } else {
              setStateSnackbarContext(
                true,
                "❌ Payment verification failed.",
                "error"
              );
            }
          });
      },

      prefill: {
        email: data.email || "",   // fallback to blank
        // contact: data.contact || "", 
      },

      theme: { color: "#FF7B00" },
    };

    const rzp1 = new window.Razorpay(options);
  
    rzp1.open();
        stopLoader && stopLoader();
  } catch (error) {
     stopLoader && stopLoader();
    setStateSnackbarContext(
      true,
      "⚠️ Something went wrong. Try again later.",
      "error"
    );
  }
};
